import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'components/AntD';

function SelectedItem({ item, title, subtitle, renderCustomActions, removeSelectedItem }) {
  return (
    <Card
      size="small"
      className="selected-item"
      bodyStyle={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}
    >
      <div className="selected-item-label tw-pr-xs">
        <div className="tw-text-ellipsis tw-overflow-hidden">{title}</div>
        {subtitle && (
          <div className="tw-text-ellipsis tw-overflow-hidden tw-text-sm">{subtitle}</div>
        )}
      </div>
      <div className="action tw-flex tw-items-center">
        {renderCustomActions(item, removeSelectedItem)}
      </div>
    </Card>
  );
}

SelectedItem.propTypes = {
  item: PropTypes.object.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  renderCustomActions: PropTypes.func.isRequired,
  removeSelectedItem: PropTypes.func.isRequired,
};

export default SelectedItem;
